import React from 'react';
import logo from '../assets/images/logo-mimina-blanco.png';
import acordeonData from '../assets/data/acordeon.json'; // Importar JSON del acordeón
import galleriesData from '../assets/data/galleries'; // Importar JSON de galerías
import CarouselGallery from '../components/CarouselGallery';
import servicesData from '../assets/data/services.json'; // Importa el JSON con los servicios

const Home = () => {
  const scrollToContent = () => {
    const nextSection = document.querySelector('.next-section');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Divide los servicios en tres columnas
  const columnCount = 3;
  const servicesPerColumn = Math.ceil(servicesData.services.length / columnCount);
  const columns = Array.from({ length: columnCount }, (_, i) =>
    servicesData.services.slice(i * servicesPerColumn, (i + 1) * servicesPerColumn)
  );

  return (
    <div>
      {/* Sección Hero */}
      <section className="hero-section d-flex align-items-center justify-content-center text-center">
        <div className="container" data-aos="fade-up">
          <img
            src={logo}
            alt="Logo de Mimina, residencia para adultos mayores"
            title="Mimina - Residencia para Adultos Mayores"
            className="d-inline-block align-text-top logo-home"
          />
          <h1 className="hero-title d-none">Mimina</h1>
          <h2 className="hero-subtitle d-none">Residencia Adultos Mayores</h2>
          <h2 className="hero-subtitle">La dignidad que merecen, la atención que necesitan</h2>

        </div>
        {/* Botón para scroll */}
        <button className="scroll-button" onClick={scrollToContent}>
          <i className="fas fa-chevron-down"></i>
        </button>
      </section>

      {/* Sección Filosofía */}
      <section className="container-fluid next-section pb-5" id="nuestra-filosofia">
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <h2 className="section-title">
              <i className="fas fa-lightbulb me-2"></i><br />
              Nuestra Filosofía
            </h2>
            <p className="section-subtitle">
              Descubre nuestra misión, visión y valores que guían cada paso que damos.
            </p>
          </div>

          {/* Misión y Visión */}
          <div className="row mb-4" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <div className="col-md-6">
              <div className="about-card">
                <h3 className="about-title">
                  <i className="fas fa-hands-helping me-2"></i> Misión
                </h3>
                <p>
                  Nuestra residencia tiene como misión prestar un servicio de calidad en cada
                  práctica, revalorizando nuestras bases de dignidad y respeto, buscando siempre
                  el bienestar físico, mental, social y emocional de cada residente y su familia.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="about-card">
                <h3 className="about-title">
                  <i className="fas fa-eye me-2"></i> Visión
                </h3>
                <p>
                  Aspiramos a ser una residencia modelo, centrada en la persona, con una
                  mirada integral hacia nuestros residentes.
                </p>
              </div>
            </div>
          </div>

          {/* Acordeón de Valores */}
          <div className="accordion" id="valuesAccordion" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <h3 className="about-title">
              <i className="fas fa-heart me-2"></i> Valores
            </h3>
            {acordeonData?.values?.map((value, index) => (
              <div className="accordion-item" key={value.id}>
                <h2 className="accordion-header" id={`heading${value.id}`}>
                  <button
                    className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${value.id}`}
                    aria-expanded={index === 0 ? 'true' : 'false'}
                    aria-controls={`collapse${value.id}`}
                  >
                    <i className={`${value.icon} me-2`}></i> {value.title}
                  </button>
                </h2>
                <div
                  id={`collapse${value.id}`}
                  className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                  aria-labelledby={`heading${value.id}`}
                  data-bs-parent="#valuesAccordion"
                >
                  <div className="accordion-body">{value.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sección Nuestra Propuesta */}
      <section className="container proposal-section pb-5" id="nuestra-propuesta">
        <div className="text-center mb-5" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
          <h2 className="section-title">
            <i className="fas fa-clipboard-list me-2"></i><br />
            Nuestra Propuesta
          </h2>
          <p className="section-subtitle">
            Descubre cómo trabajamos para brindar la mejor calidad de vida a nuestros residentes.
          </p>
        </div>

        {/* Contenido en columnas */}
        <div className="row" data-aos="fade-up">
          {/* Gestión */}
          <div className="col-md-4 mb-4" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <div className="proposal-card text-center">
              <h3 className="about-title">
                <i className="fas fa-briefcase m-2"></i><br />Gestión</h3>
              <p>
                La gestión estaría llevada a cabo por un equipo interdisciplinario, donde cada
                profesional trabaje en su área compartiendo objetivos con el resto. La
                comunicación activa y fluida serán facilitadores de buenos resultados.
              </p>
            </div>
          </div>

          {/* Recursos Humanos */}
          <div className="col-md-4 mb-4" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <div className="proposal-card text-center">
              <h3 className="about-title">
                <i className="fas fa-users m-2"></i><br />Recursos Humanos</h3>
              <p>
                En base a nuestra experiencia, el área de los recursos humanos, es posiblemente
                la más compleja. Para poder recoger los mejores frutos, propongo que más allá de
                que el personal de asistencia directa a los Adultos Mayores esté capacitado
                profesionalmente, es necesario el planteamiento de una capacitación constante en
                gerontología, calidad humana y buen trato.
              </p>
            </div>
          </div>

          {/* Proyectos Futuros */}
          <div className="col-md-4 mb-4" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <div className="proposal-card text-center">
              <h3 className="about-title">
                <i className="fas fa-seedling m-2"></i><br />Proyectos Futuros</h3>
              <p>
                Desde una mirada intergeneracional, hacer proyectos de vinculación e intercambio
                entre los niños alumnos de la escuela y los residentes de “MimiNa”, donde el
                enriquecimiento sea recíproco.
              </p>
            </div>
          </div>
        </div>

        {/* Servicios que se brindarán */}
        <div className="row" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
          <div className="col-12">
            <div className="proposal-card">
              <h3 className="about-title text-center">
                <i className="fas fa-concierge-bell m-2"></i>
                <br />
                Servicios que se brindarán
              </h3>
              <div className="row mt-4">
                {columns.map((column, columnIndex) => (
                  <div className="col-md-4" key={columnIndex}>
                    {column.map((service, serviceIndex) => (
                      <div className="service-item" key={serviceIndex}>
                        <div className="d-flex justify-content-center align-items-center"><div className="margin-l-10"><i className={`${service.icon} service-icon`}></i></div> <div>{service.name}</div></div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* Galerías dinámicas */}
      <section className="gallery-section" id="instalaciones">
        <div className="text-center mb-5" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
          <h2 className="section-title">
            <i className="fas fa-building me-2"></i><br />
            Nuestras instalaciones
          </h2>
          <p className="section-subtitle">
            Explora nuestras instalaciones diseñadas para ofrecer confort y bienestar en cada rincón.
          </p>
        </div>
        {galleriesData?.galleries?.map((gallery) => (
          <div key={gallery.id}>
            <div className="container py-5 text-center" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
              {/* Ícono sobre el título */}
              <div data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
                <i className={`${gallery.icon} gallery-icon mb-2`} aria-hidden="true"></i>
              </div>
              <h2 className="section-title" data-aos="fade-down" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">{gallery.title}</h2>
              <CarouselGallery images={gallery.images} />
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Home;






